var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad30 seller-style" },
    [
      _vm.addressVisible
        ? _c("Address", {
            attrs: {
              visible: _vm.addressVisible,
              data: _vm.list2 && _vm.list2[_vm.index]
            },
            on: {
              "update:visible": function($event) {
                _vm.addressVisible = $event
              },
              confirm: _vm.addressConfirm
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "f18 fb normal gray_2" }, [_vm._v("收货设置")]),
      _c(
        "div",
        { staticClass: "flex mar20-tb" },
        [
          _c("el-input", {
            staticClass: "w300 mar20-r",
            attrs: {
              autofocus: "",
              size: "medium",
              placeholder: "请输入客户名称/手机号",
              "prefix-icon": "el-icon-search"
            },
            model: {
              value: _vm.searchVal,
              callback: function($$v) {
                _vm.searchVal = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "searchVal"
            }
          }),
          _c(
            "el-button",
            {
              attrs: { size: "medium", type: "primary" },
              on: { click: _vm.search }
            },
            [_vm._v("查询")]
          )
        ],
        1
      ),
      _c("el-alert", {
        staticClass: "mar30-b",
        attrs: {
          title:
            "根据销售订单，自动派单，采购订单的收货地址以下方设置为准（自提则统一取供应商店铺设置自提地址）",
          type: "warning",
          "show-icon": ""
        }
      }),
      _vm.pageShow
        ? _c(
            "div",
            { staticClass: "flex flex-wrap" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "el-card",
                { key: item.idStr, staticClass: "card mar15-r mar15-b" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("div", { staticClass: "flex-auto" }, [
                        _c("div", { staticClass: "f16" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _c("div", { staticClass: "f14 mar5-t gray6" }, [
                          _vm._v("\n            联系方式"),
                          _c("span", { staticClass: "pad15-l" }, [
                            _vm._v(_vm._s(item.phone))
                          ])
                        ])
                      ]),
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        on: {
                          change: function($event) {
                            return _vm.receiveChange(index)
                          }
                        },
                        model: {
                          value: _vm.list2[index].value,
                          callback: function($$v) {
                            _vm.$set(_vm.list2[index], "value", $$v)
                          },
                          expression: "list2[index].value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.list2[index].activeAddr,
                        callback: function($$v) {
                          _vm.$set(_vm.list2[index], "activeAddr", $$v)
                        },
                        expression: "list2[index].activeAddr"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "收货地址", name: "addr" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.receiveChange(index)
                                }
                              },
                              model: {
                                value: _vm.list2[index].isCustom,
                                callback: function($$v) {
                                  _vm.$set(_vm.list2[index], "isCustom", $$v)
                                },
                                expression: "list2[index].isCustom"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("销售订单收货地址")
                              ]),
                              _c(
                                "el-radio",
                                {
                                  staticClass:
                                    "flex items-center mar10-t custom",
                                  attrs: {
                                    disabled: !_vm.list2[index].tel,
                                    label: 1
                                  }
                                },
                                [
                                  _vm.list2[index].tel
                                    ? [
                                        _c("div", { staticClass: "f12" }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.list2[index].name)
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "pad10-l" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.list2[index].tel)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "blue mar20-l",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  if (
                                                    $event.target !==
                                                    $event.currentTarget
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.addressChange(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("修改")]
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "word-normal mar5-t" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.list2[index].areaName
                                              ) +
                                                " " +
                                                _vm._s(_vm.list2[index].addr)
                                            )
                                          ]
                                        )
                                      ]
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "blue pointer",
                                          on: {
                                            click: function($event) {
                                              return _vm.addressChange(index)
                                            }
                                          }
                                        },
                                        [_vm._v("自定义")]
                                      )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "自提人信息", name: "selfAddr" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.receiveChange(index)
                                }
                              },
                              model: {
                                value: _vm.list2[index].isSelfCustom,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.list2[index],
                                    "isSelfCustom",
                                    $$v
                                  )
                                },
                                expression: "list2[index].isSelfCustom"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("销售订单自提人信息")
                              ]),
                              _c(
                                "el-radio",
                                {
                                  staticClass:
                                    "flex items-center mar10-t custom",
                                  attrs: {
                                    disabled: !_vm.list2[index].selfTel,
                                    label: 1
                                  }
                                },
                                [
                                  _vm.list2[index].selfTel
                                    ? [
                                        _c("div", { staticClass: "f12" }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.list2[index].selfName)
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "pad10-l" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.list2[index].selfTel)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "blue mar20-l",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  if (
                                                    $event.target !==
                                                    $event.currentTarget
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.addressChange(
                                                    index,
                                                    "self"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("修改")]
                                          )
                                        ])
                                      ]
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "blue pointer",
                                          on: {
                                            click: function($event) {
                                              return _vm.addressChange(
                                                index,
                                                "self"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("自定义")]
                                      )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.pageTotal > 10
        ? _c(
            "div",
            { staticClass: "flex mar20-t" },
            [
              _c("div", { staticClass: "flex-auto" }, [
                _vm._v("\n      共\n      "),
                _c("span", { staticClass: "arial" }, [
                  _vm._v(_vm._s(_vm.pageTotal))
                ]),
                _vm._v("\n      条\n    ")
              ]),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  total: _vm.pageTotal
                },
                on: { "current-change": _vm.currentChange }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "自提人信息",
            visible: _vm.addSelfVisible,
            width: "500px",
            center: "",
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addSelfVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "selfForm",
              attrs: {
                model: _vm.selfForm,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "自提人", prop: "selfName" } },
                [
                  !_vm.isSelfEdit
                    ? _c("span", [_vm._v(_vm._s(_vm.selfForm.selfName))])
                    : _c("el-input", {
                        attrs: {
                          maxlength: "10",
                          placeholder: "请输入自提人姓名"
                        },
                        model: {
                          value: _vm.selfForm.selfName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.selfForm,
                              "selfName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "selfForm.selfName"
                        }
                      })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "selfTel" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "11",
                      placeholder: "请输入自提人手机号"
                    },
                    model: {
                      value: _vm.selfForm.selfTel,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.selfForm,
                          "selfTel",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "selfForm.selfTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "text-right mar0-b" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.resetForm("selfForm")
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("selfForm")
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }